import { z } from 'zod';
import type { TFunction } from 'i18next';

const createOpenAccountSchema = (t: TFunction, formFields: Array<string>) => {
  const required = t('authPages.validation.requiredField');

  const schemaFields: Record<string, z.ZodTypeAny> = {};

  if (formFields.includes('eula')) {
    schemaFields.eula = z
      .boolean()
      .refine(val => val === true, { message: required });
  }

  if (formFields.includes('leverageValue')) {
    schemaFields.leverageValue = z.string().nonempty({ message: required });
  }

  formFields.forEach(field => {
    if (field !== 'eula') {
      schemaFields[field] = z.string().nonempty({ message: required });
    }
  });

  const schema = z.object(schemaFields);

  return schema;
};

type OpenAccountFormValues = z.infer<
  ReturnType<typeof createOpenAccountSchema>
>;

export { createOpenAccountSchema, type OpenAccountFormValues };
